import React from "react";
import LetsWork from "../components/LetsWorkTogether";
import { service } from "../../src/data/service";
import ServiceVertical from "../components/ServiceVertical";

const Services = () => {
  return (
    <>
      <div className="services section-title mt-5 mb-3">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7 mx-auto">
              <div className="services-title mb-5 mt-5">
                <h1 className="title-font title-font-size md-3">Services</h1>

                <ServiceVertical />

                <p className="title-text mt-4 mb-4 title-font-2">
                  Our services are built for your business needs
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            {service.map((service) => (
              <div className="col-12 col-lg-6 mb-5" key={service.id}>
                <div className="card">
                  <img
                    className="card-img-top"
                    src={service.image}
                    alt="Card image cap"
                  />
                  <div className="card-body">
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text">{service.description}</p>
                    <a href="#" className="btn btn-primary">
                      Go somewhere
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <LetsWork />
    </>
  );
};

export default Services;
